module.exports = __webpack_public_path__ + "img/PR.0b53de19.jpg";